'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _omit = require('../utils/underscore/omit');

var _omit2 = _interopRequireDefault(_omit);

var _PageConstants = require('./PageConstants');

var _UIAbstractPageTemplate = require('./UIAbstractPageTemplate');

var _UIAbstractPageTemplate2 = _interopRequireDefault(_UIAbstractPageTemplate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function UIDashboardPage(props) {
  return _react2.default.createElement(_UIAbstractPageTemplate2.default, _extends({}, props, {
    horizontalDivider: true,
    mainSectionBackgroundColor: _PageConstants.CARD_BACKGROUND
  }));
}

UIDashboardPage.propTypes = (0, _omit2.default)(_UIAbstractPageTemplate2.default.propTypes, 'horizontalDivider', 'mainSectionBackgroundColor');
UIDashboardPage.defaultProps = (0, _omit2.default)(_UIAbstractPageTemplate2.default.defaultProps, 'horizontalDivider', 'mainSectionBackgroundColor');

UIDashboardPage.displayName = 'UIDashboardPage';

exports.default = UIDashboardPage;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2750/js/page/UIDashboardPage.js
// module id = 594
// module chunks = 171